import { render, staticRenderFns } from "./CommuneForm.vue?vue&type=template&id=8b31505e&scoped=true&lang=pug"
import script from "./CommuneForm.vue?vue&type=script&lang=js"
export * from "./CommuneForm.vue?vue&type=script&lang=js"
import style0 from "./CommuneForm.vue?vue&type=style&index=0&id=8b31505e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b31505e",
  null
  
)

export default component.exports